import * as React from 'react';
import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import { withCampaignFilterValues } from '../../../features/campaigns-management/components/campaigns-filters/components/with-campaign-filter-values/with-campaign-filter-values';
import { filterCampaignsByModels } from '../../../features/campaigns-management/store/slices/campaigns.slice';
import InputLabel from '../../../features/shared/components/ui/InputLabel';
import BaseSelectWithCheckboxes from '../base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import withModelsOptions from './hocs/with-model-options/with-models-options';
import { ModelsDropdownProps } from './types/models-dropdown-props.type';

export const ModelsDropdown: FunctionComponent<ModelsDropdownProps> = (
  props: PropsWithChildren<ModelsDropdownProps>
): ReactElement => {
  const {
    campaignSelectFilters: { modelIds: selectedModelIds },
    values: { modelIds },
    setFieldValue,
    options,
  } = props;

  const selectedModelsMapped = options
    .filter(item => selectedModelIds.includes(item.id))
    .map(item => item.id);

  const onModelsChange = useSelectWithCheckboxesOnChange(
    'modelIds',
    setFieldValue,
    filterCampaignsByModels
  );

  return (
    <FormControl
      data-testid="models-dropdown-form-control"
      key="models-filter"
      variant="filled"
      classes={{
        root: 'form-control-main',
      }}
      disabled={!options.length}
    >
      <InputLabel id="multiple-checkbox-label">Vehicle Model</InputLabel>
      <BaseSelectWithCheckboxes
        id="modelIds"
        key="campaign-models"
        name="modelIds"
        selectOptions={options}
        value={selectedModelIds ? selectedModelsMapped : modelIds}
        onChange={onModelsChange}
        clearMultiSelectFilterAction={filterCampaignsByModels}
      />
    </FormControl>
  );
};

export default withCampaignFilterValues(withModelsOptions(ModelsDropdown));
